module.exports = __webpack_public_path__ + "static/media/osasuna_harinadetrigo.3c6071d3.png";